'use client'

import Link from 'next/link'
import React from 'react'

import { nextLinkHrefFromPathWithOptionalHash } from '@/_lib/next-link-href'
import { handleProgramaticScroll } from '@/_lib/utils'

interface IHeroCardMediumButton {
	text: string
	href: string
	className?: string
	icon?: string
}

interface IHeroCardMediumProps {
	title: string
	decorativeImageSrc?: string
	decorativeImageAlt?: string
	buttons?: IHeroCardMediumButton[]
}

const ZHeroCardMedium: React.FC<IHeroCardMediumProps> = ({
	title,
	decorativeImageSrc,
	decorativeImageAlt = '',
	buttons
}) => (
	<div className='hero-card-medium'>
		{decorativeImageSrc && (
			<img src={decorativeImageSrc} alt={decorativeImageAlt} className='background-image' />
		)}

		<div className='content'>
			<p className='title'>{title}</p>
			{buttons &&
				buttons.map((button, index) => (
					<Link
						key={index}
						href={nextLinkHrefFromPathWithOptionalHash(button.href)}
						className={button.className || 'btn_basic type2'}
						prefetch={false}
						onClick={handleProgramaticScroll}
					>
						<span>{button.text}</span>
						<span>
							<span>
								<svg className='sico'>
									<use
										href={`/assets/layout/icons.svg#${
											button.icon || 's_ar2_r'
										}`}
									/>
								</svg>
							</span>
							<span>
								<svg className='sico'>
									<use
										href={`/assets/layout/icons.svg#${
											button.icon || 's_ar2_r'
										}`}
									/>
								</svg>
							</span>
						</span>
					</Link>
				))}
		</div>
	</div>
)

export default ZHeroCardMedium
